import { defineMessage } from 'services/localization';

export const messages = {
    tooltipTitle: defineMessage('nudge_is_unavailable_due_to_one_of_the_following'),
    tooltipItem1: defineMessage('less_than_hours_since_request_creation'),
    tooltipItem2: defineMessage('less_than_hours_since_review_step_completed'),
    tooltipItem3: defineMessage('less_than_hours_since_last_nudge'),
};
